import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaQuoteLeft } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Testimonials = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      id: 1,
      quote: "testimonial1",
      author: "Ahmed M.",
      role: "Architecture Student"
    },
    {
      id: 2,
      quote: "testimonial2",
      author: "Sarah K.",
      role: "Computer Science Student"
    },
    {
      id: 3,
      quote: "testimonial3",
      author: "Mohammed R.",
      role: "Scholarship Recipient"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">
          {t('testimonials.title')}
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <FaQuoteLeft className="text-primary-500 text-2xl mb-4" />
              <p className="text-gray-600 italic mb-4">
                "{t(`testimonials.${testimonial.quote}`)}"
              </p>
              <div className="font-semibold text-gray-800">
                {testimonial.author}
              </div>
              <div className="text-sm text-gray-500">
                {testimonial.role}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;